import Typography from "@mui/material/Typography";
import {alpha, Box, Divider, Grid, IconButton, Link, Stack} from "@mui/material";
import genie_logo from '../../assets/images/logo.svg'
import useFooterLinks from "./useFooterLinks";
import FooterLinks from "./FooterLinks";
import {useTranslation} from "react-i18next";
import * as React from "react";
import ReactGA from "react-ga4";
import {useTheme} from "@mui/material/styles";
import useSocialMedia from "../../hooks/useSocialMedia";
import SecurePayments from "../../component/shared/secure-payments/SecurePayments";

const Footer = () => {
    const {exploreMore, help, legal} = useFooterLinks()
    const {t} = useTranslation()
    const theme = useTheme()
    const {socialMedia} = useSocialMedia()

    const handleOnSocialMediaClick = (label: string) => {
        ReactGA.event({
            category: 'Social Links',
            action: 'social_link_click',
            label,
        })
    }

    return (
        <Grid container rowSpacing={{xs: 3, md: 2}} component="footer" sx={{
            backgroundColor: alpha(theme.palette.secondary.main, .6),
            backdropFilter: "blur(5px)",
            mt: {xs: '3em', sm: '2.5em'},
            px: {xs: 2, sm: 3, md: 5},
            py: 2
        }}>
            <Grid item xs={12} md={5}>
                <Stack spacing={1.05} alignItems={{xs: "center", md: "flex-start"}}
                       textAlign={{xs: "center", md: "left"}}>
                    <Box component="img" src={genie_logo} alt="Genie logo" sx={{width: 120, height: "auto"}}/>
                    <Typography variant="body2" sx={{
                        color: alpha(theme.palette.primary.main, .72),
                        maxWidth: {xs: "100%", md: 450}
                    }}>
                        {t('app_description')}
                    </Typography>
                    <Stack direction="row" spacing={2.5} justifyContent={{xs: "center", md: "flex-start"}}>
                        {socialMedia.map((sm) => (
                            <IconButton key={sm.label} size="small" color='primary' sx={{p: 0}}
                                        onClick={() => handleOnSocialMediaClick(sm.label)}
                                        component={Link} href={sm.link} target="_blank" rel="noopener noreferrer">
                                {sm.icon}
                            </IconButton>
                        ))}
                    </Stack>
                </Stack>
            </Grid>

            <Grid item xs={12} md={7} mt={{xs: 0, md: 1}}>
                <Grid container rowSpacing={{xs: 1, md: 0}} columnSpacing={{xs: 1, sm: 1.5, md: 2.5}}
                      justifyContent={{xs: "center", md: "space-evenly"}} alignItems="flex-start">
                    <FooterLinks footerLinks={exploreMore}/>
                    <FooterLinks footerLinks={help}/>
                    <FooterLinks footerLinks={legal}/>
                </Grid>
            </Grid>

            <Grid item xs={12}>
                <Divider sx={{borderColor: alpha(theme.palette.primary.main, .14)}}/>
                <Stack direction={{xs: "column", md: "row"}} justifyContent="space-between"
                       alignItems={{xs: "center", md: "center"}} spacing={{xs: 1.15, md: 1.5}}
                       pt={{xs: 1.2, md: 1.4}}>
                    <Typography variant="body1" color="primary" textAlign={{xs: "center", sm: "left"}}>
                        &copy; Genie {new Date().getFullYear()}, {t('all_rights_reserved')}
                    </Typography>
                    <SecurePayments/>
                </Stack>
            </Grid>
        </Grid>
    )
}

export default Footer
